export function serviceWorkerRegisteredText() {
 return "Service worker registrado.."
}